import { Injectable, Provider } from '@angular/core';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { IAssetsService, IAssetsServiceToken } from './assets-service.interface';

@Injectable({
  providedIn: 'root'
})
export class AssetsService implements IAssetsService {

  public async categoryDefaultImageGetAsync(): Promise<string> {
    let base64Image = await this.base64ImageGetFromUrl(this.categoryDefaultImagePathGet());
    let indexOfComma = base64Image.indexOf(',');
    let base64ImageTrimmed = base64Image.substring(indexOfComma + 1, base64Image.length);
    return base64ImageTrimmed;
  }

  private categoryDefaultImagePathGet(): string {
    let path: string = ENVIRONMENT.categoryDefaultImagePath;
    if (path.length <= 0) {
      throw new Error('Missing path in "categoryDefaultImagePath"');
    }

    return path;
  }

  public async productDefaultImageGetAsync(): Promise<string> {
    let base64Image = await this.base64ImageGetFromUrl(this.productDefaultImagePathGet());
    let indexOfComma = base64Image.indexOf(',');
    let base64ImageTrimmed = base64Image.substring(indexOfComma + 1, base64Image.length);
    return base64ImageTrimmed;
  }

  private productDefaultImagePathGet(): string {
    let path: string = ENVIRONMENT.productDefaultImagePath;
    if (path.length <= 0) {
      throw new Error('Missing path in "productDefaultImagePath"');
    }

    return path;
  }

  private async base64ImageGetFromUrl(imageUrl: string): Promise<string> {
    let res = await fetch(imageUrl);
    let blob = await res.blob();

    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result as string);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    });
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AssetsServiceProvider: Provider[] = [
  { provide: IAssetsServiceToken, useExisting: AssetsService }
];
